module.exports = __webpack_public_path__ + "img/3_80.9596d196.png";